import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Menu, User } from 'lucide-react';
import Sidebar from './Sidebar';
import { NotificationCenter } from '@/components/notifications/NotificationCenter';
import { useAuthStore } from '@/stores/authStore';

export const AppLayout: React.FC = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuthStore();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-secondary-900">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        variant="user"
      />

      {/* Main content */}
      <div className="lg:ml-64 min-h-screen flex flex-col">
        {/* Top header */}
        <header className="bg-white dark:bg-secondary-800 border-b border-gray-200 dark:border-secondary-700 sticky top-0 z-30">
          <div className="flex items-center justify-between px-4 py-3">
            {/* Mobile menu button */}
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-secondary-700"
              aria-label="Abrir menu"
            >
              <Menu className="w-6 h-6 text-gray-500 dark:text-gray-400" />
            </button>

            {/* Search or breadcrumb area - can be extended */}
            <div className="hidden lg:block">
              <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                Portal KeepNota
              </h1>
            </div>

            {/* Right side actions */}
            <div className="flex items-center gap-2">
              {/* Notifications */}
              <NotificationCenter />

              {/* User menu */}
              <button
                onClick={() => navigate('/app/settings')}
                className="flex items-center gap-3 pl-3 border-l border-gray-200 dark:border-secondary-700 hover:opacity-80 transition-opacity"
              >
                <div className="hidden sm:block text-right">
                  <p className="text-sm font-medium text-gray-900 dark:text-white">
                    {user?.name || 'Usuario'}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {user?.phone || ''}
                  </p>
                </div>
                <div className="w-9 h-9 bg-primary-100 dark:bg-primary-900/50 rounded-full flex items-center justify-center">
                  <User className="w-5 h-5 text-primary-600 dark:text-primary-400" />
                </div>
              </button>
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>

        {/* Footer */}
        <footer className="border-t border-gray-200 dark:border-secondary-700 py-4 px-6">
          <p className="text-center text-sm text-gray-500 dark:text-gray-400">
            KeepNota - Gestao inteligente de recibos via WhatsApp
          </p>
        </footer>
      </div>
    </div>
  );
};

export default AppLayout;
